import { GeohashResolution, H3Resolution } from "@/types/analysisHistory";

// MAX GRID CELL COUNT
export const MAX_GRID_CELL_COUNT: number =
  Number(import.meta.env.VITE_MAX_GRID_CELL_COUNT) || 10_000;

// GEOHASH CONFIG AREA SIZE IN M²
export const GEOHASH_AREA_SIZE: Record<GeohashResolution, number> = {
  [GeohashResolution.RES_1]: 25_000_000_000_000, // ≤ 5,000 km × 5,000 km
  [GeohashResolution.RES_2]: 781_250_000_000, // ≤ 1,250 km × 625 km
  [GeohashResolution.RES_3]: 24_336_000_000, // ≤ 156 km × 156 km
  [GeohashResolution.RES_4]: 762_450_000, // ≤  39.1 km × 19.5 km
  [GeohashResolution.RES_5]: 23_912_100, // ≤  4.89 km × 4.89 km
  [GeohashResolution.RES_6]: 744_200 // ≤  1.22 km × 0.61 km
};

// GEOHASH CONFIG RESOLUTION LABEL
export const GEOHASH_RESOLUTION_LABEL: Record<GeohashResolution, string> = {
  [GeohashResolution.RES_1]: "≤ 5,000km x 5,000km",
  [GeohashResolution.RES_2]: "≤ 1,250km x 625km",
  [GeohashResolution.RES_3]: "≤ 156km x 156km",
  [GeohashResolution.RES_4]: "≤ 39.1km x 19.5km",
  [GeohashResolution.RES_5]: "≤ 4.89km x 4.89km",
  [GeohashResolution.RES_6]: "≤ 1.22km x 0.61km"
};

// H3 CONFIG AREA SIZE IN M²
export const H3_AREA_SIZE: Record<H3Resolution, number> = {
  [H3Resolution.LEVEL_1]: 609_788_440_000, // 609,788.44 km²
  [H3Resolution.LEVEL_2]: 86_801_780_000, //  86,801.78 km²
  [H3Resolution.LEVEL_3]: 12_393_430_000, //  12,393.43 km²
  [H3Resolution.LEVEL_4]: 1_770_340_000, //   1,770.34 km²
  [H3Resolution.LEVEL_5]: 252_900_000, //     252.90 km²
  [H3Resolution.LEVEL_6]: 36_120_000, //      36.12 km²
  [H3Resolution.LEVEL_7]: 5_160_000, //       5.16 km²
  [H3Resolution.LEVEL_8]: 730_000, //       0.73 km²
  [H3Resolution.LEVEL_9]: 100_000, //       0.10 km²
  [H3Resolution.LEVEL_10]: 10_000 //       0.01 km²
};

// H3 CONFIG RESOLUTION META FORM LABEL and RADIUS INFO
export const H3_RESOLUTION_META: Record<
  H3Resolution,
  { radiusKm: string; areaKm2: string }
> = {
  [H3Resolution.LEVEL_1]: { radiusKm: "483.05", areaKm2: "609,788.44" },
  [H3Resolution.LEVEL_2]: { radiusKm: "182.51", areaKm2: "86,801.78" },
  [H3Resolution.LEVEL_3]: { radiusKm: "68.97", areaKm2: "12,393.43" },
  [H3Resolution.LEVEL_4]: { radiusKm: "26.07", areaKm2: "1,770.34" },
  [H3Resolution.LEVEL_5]: { radiusKm: "9.85", areaKm2: "252.90" },
  [H3Resolution.LEVEL_6]: { radiusKm: "3.72", areaKm2: "36.12" },
  [H3Resolution.LEVEL_7]: { radiusKm: "1.40", areaKm2: "5.16" },
  [H3Resolution.LEVEL_8]: { radiusKm: "0.53", areaKm2: "0.73" },
  [H3Resolution.LEVEL_9]: { radiusKm: "0.20", areaKm2: "0.10" },
  [H3Resolution.LEVEL_10]: { radiusKm: "0.07", areaKm2: "0.01" }
};
